import { checkPermissionByKey } from "../utils/checkPermissionByKey";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useState } from "react";
import axios from "axios";
import ForYouCategoryForm from "../components/ForYouCategoryForm";

const ForYouCategoryDetailView = () => {
  const userData = useSelector((state) => state?.user);
  const [isEditing, setIsEditing] = useState(false);
  const location = useLocation();
  const { category } = location.state || {};
  const [updatedUser, setUpdatedUser] = useState(category);
  const { id } = useParams();
  const businessIdentifier = userData.user?.businessIdentifier;
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  if (!category) {
    return <div>No Category data available</div>;
  }

  const handleEditToggle = () => {
    setIsEditing(true);
  };

  const handleDelete = () => {
    setShowDeleteModal(true);
  };
  
  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}/for-you-category/foryou-category/${id}`
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/for-you-category");
        }, 2000);
      } else {
        toast.error("Failed to delete category.");
      }
    } catch (error) {
      console.log("🚀 ~ handleConfirmDelete ~ error:", error)
      toast.error(error?.response?.data?.message || "Network error. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
    }
  };
  
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <>
      {!isEditing ? (
        <div style={{ display: "flex", gap: "20px" }}>
          <div style={styles.container}>
            <div style={styles.header}>
              <h2 style={styles.title}>Category Profile</h2>
              <div style={styles.buttonContainer}>
                <button
                  onClick={handleDelete}
                  style={styles.deleteButton}
                >
                  Delete
                </button>
                <button
                  onClick={handleEditToggle}
                  style={styles.editButton}
                >
                  Edit
                </button>
              </div>
            </div>
            <div style={styles.infoContainer}>
              <div style={styles.infoRow}>
                  <span style={styles.span}>Name</span>
                  <span style={styles.span}>{category.name}</span>
                </div>
                <div style={styles.infoRow}>
                  <span style={styles.span}>Type</span>
                  <span style={styles.span}>{category.categoryType}</span>
                </div>
            </div>
            {showDeleteModal && (
              <div style={styles.modalOverlay}>
                <div style={styles.modalContainer}>
                  <p style={styles.modalText}>
                    Are you sure you want to delete this category?
                  </p>
                  <button
                    style={styles.confirmButton}
                    onClick={handleConfirmDelete}
                    disabled={isDeleting}
                  >
                    {isDeleting ? "Deleting..." : "Yes, delete"}
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={handleCloseDeleteModal}
                    disabled={isDeleting}
                  >
                    No, keep it
                  </button>
                </div>
              </div>
            )}
            <ToastContainer />
          </div>
        </div>
      ) : (
        <ForYouCategoryForm user={updatedUser} />
      )}
    </>
  );
};

const styles = {
  container: {
    backgroundColor: "#fff",
    border: "0px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "Poppins",
    overflow: "hidden",
    width: "600px",
  },
  header: {
    alignItems: "center",
    backgroundColor: "#064260",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  title: {
    fontSize: "21px",
    fontWeight: 600,
    margin: 0,
  },
  buttonContainer: {
    display: "flex",
    gap: "10px",
  },
  deactivateButton: {
    backgroundColor: "#FF0000",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  activateButton: {
    backgroundColor: "#3ABF19",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  editButton: {
    backgroundColor: "#27B99A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  deleteButton : {
    backgroundColor: "#ED3A3A",
    border: "none",
    borderRadius: "35px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "10px",
    fontWeight: 500,
    padding: "8px 10px",
    width: "80px",
  },
  infoContainer: {
    border: "0",
    padding: "0",
  },
  infoRow: {
    borderBottom: "1px solid #eee",
    display: "flex",
    fontSize: "1em",
    justifyContent: "space-between",
    padding: "20px 35px",
  },
  span: {
    fontSize: "17px",
    fontWeight: 600,
    margin: 0,
  },
  modalOverlay: {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    left: 0,
    position: "fixed",
    right: 0,
    top: 0,
  },
  modalContainer: {
    backgroundColor: "#fff",
    borderRadius: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    maxWidth: "396px",
    padding: "35px 46px 55px 46px",
    textAlign: "center",
  },
  modalText: {
    fontSize: "20px",
    fontWeight: "700",
    lineHeight: "1.5",
    wordWrap: "break-word",
  },
  confirmButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  cancelButton: {
    border: "none",
    color: "#064260",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "700",
    padding: "10px 15px",
  },
  td: {
    borderBottom: "1px solid #ddd",
    padding: "19px 10px",
    textAlign: "left",
  },
};

export default ForYouCategoryDetailView;
